import React, { useState, useRef, useEffect } from "react";
import "./YearPicker.css";
import AlertMessagePopUpModal from "../../components/PopUp/AlertMessagePopUpModal";
 
const YearPicker = (props) => {
  const [currentYear,setCurrentYear] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [visible, setVisible] = useState(false);
  const [startYear, setStartYear] = useState(Math.floor(currentYear / 12) * 12);
  const pickerRef = useRef(null);
  const [error , setError] = useState(false)
 
  useEffect(()=>{
    if(props.defaultYear){
      setSelectedYear(props.defaultYear);
      setCurrentYear(props.defaultYear);
      setStartYear(Math.floor(props.defaultYear / 12) * 12);
    }
  },[props.defaultYear])
  const generateYears = () => {
    return Array.from({ length: 12 }, (_, i) => startYear + i);
  };
 
  const handleYearClick = (year) => {
    if( year < 2026 ){
    setSelectedYear(year);
    props.handleYear(year);
    setVisible(false);
    }
    else{
      setError(true);
      setVisible(false);
    }
  };
 
  const handleInputChange = (e) => {
    const year = parseInt(e.target.value, 10);
    if (!isNaN(year) && year < 2026 ) {
      setSelectedYear(year);
      props.handleYear(year)
      setStartYear(Math.floor(year / 12) * 12);
    }
    else{
      setError(true)
    }
  };
 
  const handleClickOutside = (e) => {
    if (pickerRef.current && !pickerRef.current.contains(e.target)) {
      setVisible(false);
    }
  };
 
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <>
    <div className="year-picker-container" ref={pickerRef}>
      <div className="year-picker-container-inner">
        <input className="year-picker-input"
        type="text"
        value={selectedYear}
        onChange={handleInputChange}
        onFocus={() => setVisible(true)}
      />
      <span className="year-picker-icon" onClick={() =>setVisible(true)}><svg width="17px" height="17px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 9H21M7 3V5M17 3V5M6 13H8M6 17H8M11 13H13M11 17H13M16 13H18M16 17H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      </path> 
      </g>
      </svg>
      </span></div>
      {visible && (
        <div className="year-picker-absolute-conc"
        >
          <div className="year-picker-absolute-conc-inner">
            <button onClick={() => setStartYear(startYear - 12)}>❮</button>
            <span style={{ fontWeight: "bold",fontSize:"0.875rem" }}>{startYear}</span>
            <button onClick={() => setStartYear(startYear + 12)}>❯</button>
          </div>
          <div className="year-picker-grid">
            {generateYears().map((year) => (
              <div
              className="year-picker-cell"
                key={year}
                onClick={() => handleYearClick(year)}
                style={{
                  backgroundColor: year === selectedYear ? "#1da1e5" : "#f9f9f9",
                  fontWeight: year === selectedYear ? "bold" : "normal",
                }}
              >
                {year}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
    {error && <AlertMessagePopUpModal color={"red"} content={"Please select year less than 2025"} showModal={error} handleClose={() =>setError(false)} />}</>
  );
};
 
export default YearPicker;